<template lang="html">
<div class="pgInner adsMessage" :style="'height:' + pageH + 'px;'">

      <div class="tabNavs" ref="tabNavs">
           <span>企业库</span>
           <div class="btns">
                <el-button  @click="goFrash" size="mini">刷新</el-button>
                <!-- <el-button  @click="goFrash" size="mini">导入</el-button> -->
                <el-button type="primary"  @click="goEdit('new')" size="mini">新建</el-button>
           </div>
      </div>

      <div class="seekLine">
          <div class="seekGp">
              <el-input placeholder="请输入关键字" v-model="listParams.keyword" @input="reInxList">
                    <el-button @click="reInxList" slot="append" icon="el-icon-search"></el-button>
              </el-input>
          </div>

          <div class="inpGp">
            <el-select v-model="listParams.status" clearable placeholder="状态" @change="stateChange">
              <el-option
                v-for="item in options"
                :key="item.key"
                :label="item.name"
                :value="item.key">
              </el-option>
            </el-select>
          </div>

          <div class="inpGp">
            <dic-select code="sflx"
                 :selectId="listParams.identityTypeId"
                 plaText="身份类型"
                 paramsKey="identityTypeId"
                 @selectChange="selectChange"/>
          </div>

          <div class="inpGp">
            <dic-select code="szhy"
                 :selectId="listParams.industryId"
                 plaText="行业"
                 paramsKey="industryId"
                 @selectChange="selectChange"/>
          </div>

      </div>

      <div class="pgbody">

          <el-table
             :data="listData"
             header-row-class-name="tableHead"
             @selection-change="tabSelect"
             v-loading="loading"
             style="width: 100%">

             <el-table-column
               type="selection"
               align="center"
               width="30">
             </el-table-column>

             <el-table-column
               prop="companyName"
                 type="selection"
               label="企业名称">
             </el-table-column>

             <el-table-column
               prop="staffSize"
               width="120"
               align="center"
               label="成员数量">
             </el-table-column>

             <el-table-column
               prop="identityType"
               width="120"
               align="center"
               label="身份类型">
             </el-table-column>

             <el-table-column
               prop="industry"
               align="center"
               label="行业">
             </el-table-column>

             <el-table-column
               width="120"
               align="center"
               label="状态">

                <template slot-scope="scope">
                      {{ scope.row.status | datFormate(1) }}
                </template>

             </el-table-column>

             <el-table-column
               width="120"
               align="center"
               label="注册时间">
               <template slot-scope="scope">
  {{ scope.row.createdAt | datFormate(2) }}
</template>
             </el-table-column>

             <el-table-column
               label="操作"
               align="center"
               width="180">
               <template slot-scope="scope">
  <div class="ibtn">
    <span @click="goEdit('edit', scope.row)">编辑</span>
    <div class="dvLine"></div>
  </div>
  <div class="ibtn">
    <span @click="goRemove(scope.row)">删除</span>
    <div class="dvLine"></div>
  </div>
</template>

             </el-table-column>
          </el-table>

          <div class="table-footer">

              <div class="btns" v-if="listData.length > 0">
                  <el-button @click="goRemove()" size="mini" type="danger">删除</el-button>
              </div>

              <el-pagination
                class="paging"
                v-if="allPages>1"
                @current-change="handleCurrentChange"
                :current-page="listParams.no"
                :page-count="allPages"
                layout="total, prev, pager, next, jumper">
              </el-pagination>

          </div>

      </div>

</div>
</template>

<script>
import { getEnterpriseList } from "@/api/attes/attestation";
import { enterpriseRemove } from "@/api/enterprise/index";
export default {
  computed: {
    lineStr: function () {
      var str = "left:" + this.navX + "px;";
      return str;
    }
  },
  filters: {
    datFormate: function (e, type) {
      if (type == 1) {    // 状态
        var transMap = {
          1: '未认证',
          2: '已认证',
          3: '已解散',
          4: '审核失败',
          5: '未认证'
        };
        return transMap[e];
      } else if (type == 2) {
        return e.substr(0, 11);
      }
    }
  },
  data() {
    return {
      pageH: '',

      options: [],
      listData: [],
      selectArr: [],

      loading: false,
      status: '',

      listParams: {
        keyword: '',
        industryId: '',
        identityTypeId: '',
        statusList: '',
        sort: 2,
        no: 1,
        size: 12
      },

      allPages: 0,
      allEls: 0,

      options: [
        { key: 1, name: '未认证' },
        { key: 2, name: '已认证' },
        { key: 4, name: '审核失败' }
      ],

      typeId: ''  // 活动通告类型 id
    }
  },
  methods: {
    getList: function () {
      this.loading = true;
      getEnterpriseList(this.listParams).then(res => {
        this.listData = res.enterpriseList;
        this.loading = false;
        this.allPages = res.totalPages;
        this.allEls = res.totalElements;
      })
    },
    stateChange: function (e) {
      if (e) {
        this.listParams.statusList = [e];
      } else {
        this.listParams.statusList = [];
      }

      this.reInxList();
    },
    pageFix: function () {
      this.pageH = document.documentElement.clientHeight - 50;
    },

    selectChange: function (e) {
      this.listParams[e.paramsKey] = e.id;
      this.reInxList();
    },

    goRemove: function (e) {     // 批量删除
      var vues = this;
      if (e) {
        this.tabSelect([e]);
      }
      if (this.selectArr.length > 0) {
        this.$confirm('确认要删除吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          console.log('aaa');
          enterpriseRemove({ ids: this.selectArr }).then(res => {
            console.log(res);
            vues.reInxList();
            vues.selectArr = [];
          })
        }).catch(() => {
          vues.selectArr = [];
        });
      } else {
        this.$message.error('请选择删除项！');
      }
    },

    changeState: function (status, e) {
      var vues = this;
      if (e) {
        this.tabSelect([e]);
      }
      if (this.selectArr.length > 0) {
        statusSet({ ids: this.selectArr, status: status }).then(res => {
          vues.reInxList();
          vues.selectArr = [];
        })
      } else {
        this.$message.error('请选择操作项！');
      }
    },

    goEdit: function (type, e) {   // 编辑
      var querys = {};
      if (type == 'edit') {
        querys.id = e.id;
      }
      this.$router.push({
        path: 'ent_edit',
        query: querys
      });
    },

    tabSelect: function (e, type) {
      var arrs = [];
      if (type == 1) {
        arrs = [e.id];
        this.selectArr = arrs;
        this.goRemove();
      } else {
        e.forEach(item => {
          arrs.push(item.id);
        })
        this.selectArr = arrs;
      }
    },

    handleCurrentChange: function (e) {
      this.listParams.no = e;
      this.getList();
    },
    reInxList: function () {
      this.listParams.no = 1;
      this.getList();
    },
    goFrash: function () {
      this.$emit('go-frash');
    },
    prevSet: function () {

      // 底部定位
      this.pageFix();
      this.typeIdSet();


    },
  },
  created: function () {

    this.pageFix();
    this.getList();

  }
}
</script>

<style lang="scss" scoped>
.pgInner {
  background: #f5f5f5;
}

.tabNavs {
  height: 60px;
  line-height: 60px;
  padding-left: 20px;
  background: white;
  position: relative;
  border-bottom: 1px solid #efefef;
  .btns {
    float: right;
    height: 60px;
    padding-right: 20px;
  }
}

.seekLine {
  padding: 20px;
  background: white;
  .seekGp {
    width: 420px;
    display: inline-block;
  }

  .inpGp {
    width: 150px;
    display: inline-block;
    margin-left: 12px;
  }
}

.pgbody {
  margin: 20px;
  .ibtn {
    display: inline-block;
    font-size: 14px;
    margin-right: 3px;
    span {
      cursor: pointer;
      color: #409eff;
    }
    .dvLine {
      display: inline-block;
      height: 14px;
      width: 2px;
      vertical-align: middle;
      margin-top: -2px;
      margin-left: 3px;
      background: #eaeaea;
    }
  }

  .ibtn:last-child .dvLine {
    display: none;
  }

  .table-footer {
    height: 50px;
    background: white;
    padding: 0 30px;
    text-align: right;

    .btns {
      float: left;
      line-height: 50px;
    }

    .paging {
      display: inline-block;
      margin-top: 9px;
    }
  }
}
</style>

<style lang="scss">
.adsMessage .tableHead th {
  background: #efefef;
  font-weight: normal;
  color: #666666;
}

.adsMessage .seekLine {
  .el-input__inner {
    border-radius: 0px !important;
  }

  .el-input-group__append {
    border-radius: 0px !important;
  }
}
</style>



// WEBPACK FOOTER //
// enterpriseList.vue?58e89b3e